import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface MessagesHeaderProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

export function MessagesHeader({ searchTerm, setSearchTerm }: MessagesHeaderProps) {
  return (
    <div>
      <h1 className="text-3xl font-heading font-bold text-gray-900">Mensagens</h1>
      <p className="mt-2 text-gray-600">Gerencie suas mensagens programadas</p>
      
      <div className="mt-8 bg-white p-4 md:p-6 rounded-xl shadow-card space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-medium">Mensagens Programadas</h2>
          <div className="relative w-64">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 h-4 w-4" />
            <Input
              placeholder="Buscar por proprietário ou imóvel..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>
      </div>
    </div>
  );
}